var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDepartmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.611,
    height: 22.647,
    viewBox: "0 0 21.611 22.647",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-git-network",
    "data-name": "Icon ionic-ios-git-network",
    d: "M22.138,24.9a3.794,3.794,0,0,1-3.973-3.574,3.375,3.375,0,0,1,.985-2.356A4.044,4.044,0,0,1,21.3,17.83V15.651l-5.994-2.8-5.988,2.8V17.83a3.687,3.687,0,0,1,3.135,3.493A3.794,3.794,0,0,1,8.479,24.9,3.8,3.8,0,0,1,4.5,21.323a3.375,3.375,0,0,1,.985-2.356,4.044,4.044,0,0,1,2.15-1.137v-2.9a.352.352,0,0,1,.219-.318l6.613-3.074V9.317a3.687,3.687,0,0,1-3.135-3.493A3.794,3.794,0,0,1,15.305,2.25a3.794,3.794,0,0,1,3.973,3.574,3.375,3.375,0,0,1-.985,2.356,4.044,4.044,0,0,1-2.15,1.137v2.219l6.613,3.074a.352.352,0,0,1,.219.318v2.9a3.687,3.687,0,0,1,3.135,3.493A3.794,3.794,0,0,1,22.138,24.9ZM6.177,21.323a2.191,2.191,0,0,0,2.3,2.063,2.191,2.191,0,0,0,2.3-2.063,2.191,2.191,0,0,0-2.3-2.063A2.191,2.191,0,0,0,6.177,21.323ZM17.6,5.824a2.191,2.191,0,0,0-2.3-2.063,2.191,2.191,0,0,0-2.3,2.063,2.191,2.191,0,0,0,2.3,2.063A2.191,2.191,0,0,0,17.6,5.824Zm4.536,13.432a2.191,2.191,0,0,0-2.3,2.063,2.309,2.309,0,0,0,4.592,0A2.194,2.194,0,0,0,22.138,19.256Z",
    transform: "translate(-4.5 -2.25)",
    fill: "#b2b1b1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepartmentIcon);
export default __webpack_public_path__ + "static/media/department-icon.50b5452520bd8c275a7425acd44a752f.svg";
export { ForwardRef as ReactComponent };